<template>
  <!-- CONTAINER TO FIX POSITION OF THE CARD -->
	<div class="position-fixed help-panel">
    <!-- CARD -->
    <div v-if="isCardOpen" class="card shadow-lg" :class="$breakpoint.smAndDown ? 'p-4 bottom-100-px' : 'bottom-60-px py-4 px-5'">
      <div v-if="userLoggedIn.category === 'buyer'" class="d-block">
        <h3>Contact the Sales Team:</h3>
        <ul class="list-group list-group-flush mx-auto">
            <li class="list-group-item border-0">
                <a class="text-tertiary heading-small font-weight-normal" :href="`tel:${SALES_CONTACT_NUMBER}`">
                    <i class="fas fa-phone mr-2 text-primary" />{{ SALES_CONTACT_NUMBER }}
                </a>
            </li>
            <li class="list-group-item border-0">
                <a class="text-tertiary heading-small font-weight-normal" :href="`mailto:${SALES_SUPPORT_EMAIL}`">
                    <i class="fas fa-envelope mr-2 text-primary" />{{ SALES_SUPPORT_EMAIL }}
                </a>
            </li>
        </ul>
      </div>
      <div class="d-block">
        <h3>In Need of Technical Help?</h3>
        <ul class="list-group list-group-flush mx-auto">
          <!-- CONTACT NUMBER -->
          <li class="list-group-item border-0">
            <a class="text-tertiary heading-small font-weight-normal" :href="`tel:${CONTACT_NUMBER}`">
              <i class="fas fa-phone mr-2 text-primary" />{{ CONTACT_NUMBER }}
            </a>
          </li>

          <!-- SUPPORT EMAIL -->
          <li class="list-group-item border-0">
            <a class="text-tertiary heading-small font-weight-normal" :href="`mailto:${SUPPORT_EMAIL}`">
              <i class="fas fa-envelope mr-2 text-primary" />{{ SUPPORT_EMAIL }}
            </a>
          </li>
        </ul>
      </div>
      <div class="d-block">
        <h3 class="mb-4">Help Guides &amp; FAQs?</h3>
        <p>Click this <a :href="helpGuides.CONFLUENCE_LINK" target="_blank">link</a> and use the following:</p>
        <p class="mb-1 heading-small">Username: <span class="font-weight-bold">{{ helpGuides.USERNAME }}</span></p>
        <p class="heading-small">Password: <span class="font-weight-bold">{{ helpGuides.PASSWORD }}</span></p>
      </div>
    <!-- CARD -->
    </div>
    
    <!-- BUTTON TO OPEN/HIDE CARD ABOVE -->
    <button class="btn btn-new--mobile"
      :class="[isCardOpen ? 'btn-danger' : 'btn-secondary', $breakpoint.smAndDown ? 'btn-icon mb-5' : 'btn-50']"
      @click="openCard()"
    >
      <i class="heading-medium fas" :class="isCardOpen ? 'fa-times' : 'fa-question'" />
    </button>
  <!-- CONTAINER TO FIX POSITION OF THE CARD -->
  </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import { mapState } from "vuex";

export default {
  mixins: [breakpoint],
  data(){
    return {
      isCardOpen: false,
      SALES_CONTACT_NUMBER: "01932 843 354",
      SALES_SUPPORT_EMAIL: "salesteam@prax.com",
      CONTACT_NUMBER: "+44 80 8189 0758",
      SUPPORT_EMAIL: "harvestsupport@dtn.com",
      helpGuides: {
          CONFLUENCE_LINK: "https://harvestdirect-kb.atlassian.net/wiki/spaces/HBSD/overview",
          USERNAME: "harvestdirect-kb@onlinefuels.com",
          PASSWORD: "9mXzMzkGvT2rdyPD"
      }
    }
  },
  computed: {
    ...mapState("login", ["userLoggedIn"])
  },
  methods: {
    openCard: function(){
      this.isCardOpen = !this.isCardOpen;
    }
  }
}
</script>

<style lang="scss" scoped>
.help-panel {
  position: fixed;
  bottom: 75px;
  right: 20px;
  z-index: 999;
}

.bottom- {
  &60-px {
    bottom: 60px;
  }
  &100-px {
    bottom: 100px;
  }
}

.btn-50 {
  width: 50px!important;
  height: 50px;
}
</style>